const it = {
  // Navbar
  nav: {
    features: "Funzionalità",
    pricing: "Prezzi",
    blog: "Blog",
    about: "Chi siamo",
    guides: "Guide",
    guide1: "Link in Bio per Creator",
    guide2: "Link in Bio per Instagram",
    guide3: "Monetizzare Instagram",
    guide4: "Vendere Prodotti Digitali",
    guide5: "Link in Bio Gratis",
    guide6: "Prenotazioni Online",
    dashboard: "Dashboard",
    logout: "Esci",
    login: "Accedi",
    register: "Registrati gratis",
  },
  // Hero
  hero: {
    badge: "La piattaforma di conversione per creator",
    title1: "Il link‑in‑bio che ",
    titleHighlight: "trasforma follower in clienti",
    desc: "Un <strong>link in bio</strong> che vende davvero: prodotti, <strong>prenotazioni</strong> e analytics in un'unica pagina. Il <strong>Deeplink™</strong> apre i tuoi link nel browser reale invece che in quello interno dei social, così pagamenti e prenotazioni si completano. E in più, <strong>ti paghiamo per ogni click ricevuto</strong>.",
    cta: "Inizia Gratis Ora",
    ctaHint: "Prova PRO inclusa per 7 giorni",
    subCta: "Nessuna carta richiesta · Setup in 1 minuto · Disdici quando vuoi",
    imgAlt: "Mockup dell'app TuttiIMieiLink",
    socialProof: "600+ creator · 4.9/5",
    stickyCta: "Inizia gratis",
    stickyCtaVariantB: "Crea il tuo link che vende",
    stickyCtaVariantC: "Provalo gratis per 7 giorni →",
    stickyCtaVariantD: "Inizia ora — è gratis",
    statCreators: "creator attivi",
    statClicks: "click monetizzati",
    statRating: "su 5 stelle",
    demoBadge: "Demo live",
    demoCaption: "Guarda come un click diventa una vendita",
    demoSaleLabel: "+€12 vendita",
    demoLinkLabel: "Il mio nuovo corso",
  },
  // Problem
  problem: {
    badge: "Il problema",
    title1: "La maggior parte dei link‑in‑bio è solo una ",
    titleMuted: "lista di link",
    desc: "Ricevi migliaia di click dai social ma non li trasformi in clienti. Il traffico c'è, le vendite no.",
    items: [
      "Il traffico arriva ma nessuno compra",
      "I tuoi analytics mostrano click, non conversioni",
      "Il browser in-app blocca checkout e iscrizioni",
    ],
  },
  // Solution
  solution: {
    badge: "La soluzione",
    title1: "Trasforma il tuo link in un ",
    titleHighlight: "funnel di vendita",
    desc: "Non un altro link‑in‑bio. Un sistema completo per convertire follower in clienti paganti.",
    items: [
      { title: "Landing page personalizzata", desc: "Un editor semplice per creare pagine che convertono, non semplici liste di link." },
      { title: "Vendita prodotti digitali", desc: "Vendi ebook, corsi, template e consulenze direttamente dalla tua pagina." },
      { title: "Raccolta email e lead", desc: "Form integrati e lead magnet per costruire la tua lista e vendere di più." },
      { title: "Analytics conversioni", desc: "Non solo click: misura CTR, conversioni e fatturato generato da ogni link." },
    ],
  },
  // HowItWorks
  howItWorks: {
    title: "Da follower a cliente in 3 step",
    subtitle: "Setup veloce, risultati immediati",
    steps: [
      { title: "Crea la tua pagina", desc: "Registrati gratis e personalizza la tua landing page con il nostro editor semplice e veloce." },
      { title: "Aggiungi link o prodotti", desc: "Inserisci i tuoi link di vendita, prodotti digitali, form di contatto e lead magnet." },
      { title: "Trasforma i click in clienti", desc: "Deeplink™ e analytics di conversione ti mostrano cosa funziona. Ottimizza e scala il fatturato." },
    ],
  },
  // Features
  features: {
    badge: "Funzioni principali",
    title: "Tutto ciò che serve per convertire",
    desc: "Ogni funzione è progettata per trasformare il traffico social in clienti paganti.",
    uniqueBadge: "UNICI IN ITALIA",
    items: [
      { title: "Guadagna per ogni click", desc: "Siamo l'unica piattaforma che ti paga per i click ricevuti. Fino a €0.01 per click: più traffico porti, più guadagni. Nessun altro lo fa." },
      { title: "Smart Landing Page", desc: "Un editor a blocchi per creare pagine di conversione: bottoni, video, immagini, countdown e testimonial. Tutto ottimizzato per vendere." },
      { title: "Lead Capture", desc: "Form integrati per raccogliere email e contatti. Aggiungi lead magnet per far crescere la tua lista e vendere di più." },
      { title: "Deeplink™", desc: "I link social si aprono nel browser in-app e bloccano i checkout. La nostra tecnologia forza l'apertura nel browser reale: +40% di conversioni." },
      { title: "Shield Protection™", desc: "Filtra bot e click sospetti in tempo reale. Paghi solo per visitatori veri che comprano." },
      { title: "Geo Filter", desc: "Mostra offerte diverse in base al paese del visitatore. Prezzi localizzati e redirect per store regionali." },
      { title: "Analytics Conversioni", desc: "Non solo click: misura CTR, conversioni e fatturato. Scopri i link più performanti e ottimizza la tua strategia." },
    ],
  },
  // Comparison
  comparison: {
    badge: "Confronto onesto",
    title: "Perché non sei su Linktree?",
    desc: "Linktree è un ottimo inizio. Ma se vuoi <strong>vendere</strong>, servono strumenti diversi.",
    featureCol: "Funzionalità",
    rows: [
      "Guadagni per ogni click ricevuto",
      "Vendita prodotti digitali integrata",
      "Vendita prodotti fisici con spedizione",
      "Deeplink™ (apre nel browser reale)",
      "Shield Protection™ anti-bot",
      "Geo Filter per offerte localizzate",
      "Analytics di conversione",
      "Landing page personalizzabile",
      "Dominio personalizzato",
      "+40% conversioni su checkout",
      "Multi-link con tracking vendite",
    ],
  },
  // SmartLinks
  smartLinks: {
    badge: "Automazione Intelligente",
    title: "Link che si adattano al tuo pubblico",
    desc: "I tuoi link cambiano automaticamente in base al dispositivo, all'orario e al paese del visitatore. Zero configurazione, massime conversioni.",
    autoLabel: "100% automatico ✨",
    bottomHighlight: "Nessun competitor offre link intelligenti automatici. Solo TuttiIMieiLink.",
    rules: [
      {
        icon: "device",
        title: "Dispositivo Intelligente",
        desc: "Mostra link diversi a chi naviga da iPhone o Android. Invia automaticamente all'App Store giusto o alla versione mobile ottimizzata.",
        example: "📱 Scarica su App Store",
      },
      {
        icon: "time",
        title: "Orario del Giorno",
        desc: "Mostra offerte diverse in base all'orario: promozioni flash la sera, contenuti formativi la mattina. Il tuo funnel lavora 24/7.",
        example: "🌙 Offerta serale -30%",
      },
      {
        icon: "geo",
        title: "Paese di Provenienza",
        desc: "Offerte localizzate automaticamente: prezzi in valuta locale, link a store regionali, contenuti nella lingua del visitatore.",
        example: "🇩🇪 Shop Deutschland",
      },
    ],
  },
  // SocialLogos
  socialLogos: {
    title: "Integrato con le piattaforme che ami",
  },
  // CreatorCarousel
  creatorCarousel: {
    title: "Creator che vendono con TuttiIMieiLink",
    desc: "Unisciti a migliaia di creator che monetizzano il proprio pubblico ogni giorno",
  },
  // Stats
  stats: {
    badge: "I risultati parlano",
    title: "Non vanity metrics. Vendite reali.",
    items: [
      { value: "+40%", label: "Conversioni", desc: "Aumento medio delle conversioni grazie a Deeplink™ che apre i link nel browser reale." },
      { value: "600+", label: "Creator attivi", desc: "Creator italiani stanno già usando TuttiIMieiLink per monetizzare il proprio pubblico." },
      { value: "700+", label: "Click tracciati", desc: "Click reali tracciati e ottimizzati attraverso la piattaforma, in continua crescita." },
    ],
  },
  // Testimonial
  testimonial: {
    badge: "Testimonianze",
    title: "Creator che vendono di più",
    desc: "Non fidarti solo di noi. Ecco cosa dicono i creator che usano TuttiIMieiLink ogni giorno.",
    items: [
      { quote: "Da quando uso TuttiIMieiLink le vendite dei miei corsi da Instagram sono aumentate del 60%. Il Deeplink™ fa tutta la differenza.", name: "Luca M.", role: "Creator & Digital Entrepreneur", metric: "+60% vendite" },
      { quote: "Ho provato Linktree, Beacons e altri. Con TuttiIMieiLink il tasso di conversione è il doppio. Lo Shield Protection mi ha salvato da migliaia di click bot.", name: "Chiara R.", role: "Fashion Influencer · 120K follower", metric: "2x conversioni" },
      { quote: "Il Geo Filter è pazzesco: mostro offerte diverse a chi è in Italia e chi è all'estero. I competitor non ce l'hanno. Setup in 5 minuti.", name: "Marco B.", role: "E-commerce Owner", metric: "+40% CTR" },
      { quote: "Finalmente una piattaforma pensata per vendere, non solo per mettere link. Le analytics di conversione mi dicono esattamente cosa funziona.", name: "Sara T.", role: "Coach & Consulente", metric: "3x ROI" },
      { quote: "Il mio pubblico è 80% mobile da Instagram. Prima metà dei click moriva nel browser in-app, ora con Deeplink™ arrivano tutti al sito reale.", name: "Davide P.", role: "YouTuber & Podcaster", metric: "-50% bounce" },
      { quote: "Ho migrato tutto in un pomeriggio. L'interfaccia è semplicissima e il supporto risponde in italiano. Non torno più indietro.", name: "Elena F.", role: "Food Blogger", metric: "5 min setup" },
      { quote: "Uso TuttiIMieiLink per vendere i miei preset Lightroom. Da quando ho attivato il pay-per-click guadagno anche solo dai visitatori che non comprano. Geniale.", name: "Giulia V.", role: "Fotografa & Content Creator", metric: "+€200/mese" },
      { quote: "Gestisco 5 creator con il piano Agency. Avere tutto in un unico pannello con analytics globali mi fa risparmiare ore ogni settimana.", name: "Andrea C.", role: "Social Media Manager", metric: "5 creator, 1 pannello" },
      { quote: "I miei studenti cliccano il link in bio e arrivano direttamente alla pagina di checkout senza blocchi. Le iscrizioni ai miei corsi sono raddoppiate.", name: "Federica L.", role: "Insegnante di Yoga Online", metric: "+100% iscrizioni" },
      { quote: "Ho iniziato con il piano Free per provare. Dopo una settimana sono passato a Creator perché i risultati erano troppo buoni per non investire.", name: "Tommaso G.", role: "Musicista Indipendente", metric: "Free → Creator in 7gg" },
    ],
  },
  // Pricing
  pricing: {
    badge: "Investi nelle tue vendite",
    title: "Quanto vale un follower che compra?",
    desc: "Scegli il piano che fa crescere il tuo fatturato.",
    annual: "Annuale -20%",
    monthly: "Mensile",
    earningsBanner: "Unica piattaforma che ti paga per ogni click ricevuto",
    socialProof: "Già <strong>1.000+</strong> creator usano TuttiMieiLink",
    mostPopular: "Più popolare",
    saveAnnual: "Risparmia il 20% con il piano annuale.",
    loading: "Caricamento...",
    plans: [
      {
        name: "Free",
        desc: "Prova la piattaforma con le funzionalità base. Quando vorrai crescere, passa a Starter.",
        links: "Fino a 10 link",
        cta: "Inizia gratis",
        features: [
          "1 pagina",
          "Fino a 10 link",
          "Tecnologia Deeplink™",
          "Shield Protection™",
          "Analytics base (visite e click)",
          "Tip Jar — ricevi donazioni",
          "Temi e font personalizzabili",
          "Guadagna €0.005 per click",
        ],
      },
      {
        name: "Starter",
        desc: "Link illimitati, fino a 3 prodotti e analytics degli ultimi 7 giorni. Perfetto per iniziare a vendere.",
        links: "Link illimitati",
        cta: "Prova gratis 7 giorni",
        features: [
          "Tutto in Free, più:",
          "Link illimitati",
          "Fino a 3 prodotti digitali",
          "Analytics ultimi 7 giorni",
          "Codici sconto",
          "Tip Jar personalizzato",
          "Temi premium",
          "Guadagna €0.005 per click",
        ],
      },
      {
        name: "Creator",
        desc: "Analytics avanzati, lead capture, vendita prodotti e membership per massimizzare ogni conversione.",
        links: "Link illimitati",
        cta: "Prova gratis 7 giorni",
        features: [
          "Tutto in Starter, più:",
          "Prodotti illimitati",
          "1 Dominio Personalizzato",
          "Analytics conversioni e CTR",
          "Lead Capture e form email",
          "Prodotti fisici con spedizione",
          "Bundle di prodotti",
          "Membership e abbonati",
          "Testimonianze",
          "Social Proof in tempo reale",
          "Smart Bio per fonte traffico",
          "Smart Links con scheduling",
          "Creator Score",
          "A/B Test posizione link",
          "Pixel Meta, TikTok e GA",
          "Automazioni email",
          "Guadagna €0.01 per click (2x)",
        ],
      },
      {
        name: "Agency",
        desc: "Gestisci più creator, funnel multipli e dashboard avanzata da un unico pannello.",
        links: "Link illimitati",
        cta: "Prova gratis 7 giorni",
        features: [
          "Tutto in Creator, più:",
          "2 Domini Personalizzati",
          "Gestione multi creator",
          "Collaborazioni tra creator",
          "Funnel multipli con AI",
          "Dashboard analytics globale",
          "CRM contatti e lead",
          "Import prodotti da CSV",
          "Programma referral",
          "Guadagna €0.01 per click (2x)",
        ],
      },
    ],
    miniTestimonials: [
      { quote: "Da quando uso TuttiMieiLink le mie vendite sono aumentate del 35%. Il checkout express è una svolta!", name: "Giulia R.", role: "Content Creator" },
      { quote: "Finalmente una piattaforma che mi paga per i click. Ho già guadagnato €120 in un mese.", name: "Marco T.", role: "Influencer" },
      { quote: "Ho provato Linktree per 2 anni. Con TuttiMieiLink i miei follower comprano davvero.", name: "Sara M.", role: "Fashion Blogger" },
    ],
  },
  // FAQ
  faq: {
    badge: "FAQ",
    title: "Domande frequenti",
    items: [
      { q: "In che modo TuttiIMieiLink mi aiuta a vendere di più?", a: "La tecnologia Deeplink™ forza l'apertura dei tuoi link nel browser reale, bypassando il browser in-app che blocca checkout e pagamenti. Risultato: +40% di conversioni medie su acquisti e iscrizioni." },
      { q: "Che differenza c'è rispetto a Linktree o altri link-in-bio?", a: "Gli altri ti danno una lista di link. Noi ti diamo un sistema di vendita: Deeplink™ per conversioni, Shield Protection™ contro il traffico fake, Geo Filter per offerte localizzate e analytics focalizzate sulle conversioni, non sulle vanity metrics." },
      { q: "Posso usarlo per vendere corsi, merch, consulenze?", a: "Assolutamente. Qualsiasi link di vendita — Gumroad, Shopify, Teachable, Calendly, Ko-fi — funziona meglio con Deeplink™. I tuoi follower arrivano al checkout senza blocchi." },
      { q: "Come funziona Shield Protection™?", a: "Shield analizza il traffico in tempo reale e filtra bot, click sospetti e visite fake. Così le tue analytics mostrano solo visitatori reali e il tuo budget ads non viene sprecato." },
      { q: "Posso collegare un dominio personalizzato?", a: "Sì! Con il piano Creator o superiore puoi collegare il tuo dominio per un aspetto più professionale e aumentare la fiducia dei tuoi potenziali clienti." },
    ],
  },
  // CTA Footer
  ctaFooter: {
    title: "Smetti di perdere vendite dal tuo bio link",
    desc: "Ogni giorno che passi con un link-in-bio generico, perdi clienti. Deeplink™, Shield e analytics di conversione: tutto gratis per iniziare.",
    cta: "Inizia gratis",
    brandDesc: "Il link-in-bio che fa vendere i creator.",
    copyright: "© {{year}} TuttiIMieiLink. Tutti i diritti riservati.",
    footerSections: {
      product: "Prodotto",
      resources: "Risorse",
      company: "Azienda",
      legal: "Legale",
    },
    footerLinks: {
      features: "Funzionalità",
      pricing: "Prezzi",
      guide1: "Link in Bio per Creator",
      guide2: "Link in Bio per Instagram",
      guide3: "Monetizzare Instagram",
      guide4: "Vendere Prodotti Digitali",
      guide5: "Link in Bio Gratis",
      about: "Chi siamo",
      contact: "Contatti",
      terms: "Termini d'uso",
      privacy: "Privacy Policy",
      cookie: "Cookie Policy",
    },
  },
  // ScrollingTags
  scrollingTags: ["Vendo Corsi Online", "Merch & E-commerce", "Consulenze", "Affiliazioni", "Digital Products", "Coaching"],
  // Auth page
  auth: {
    back: "Torna alla home",
    loginTitle: "Accedi al tuo account",
    loginSubtitle: "Bentornato! Accedi per gestire la tua pagina",
    registerTitle: "Crea un nuovo account",
    continueGoogle: "Continua con Google",
    continueApple: "Continua con Apple",
    or: "oppure",
    email: "Email",
    password: "Password",
    forgotPassword: "Password dimenticata?",
    login: "Accedi",
    register: "Registrati",
    loading: "Caricamento...",
    noAccount: "Non hai un account?",
    hasAccount: "Hai già un account?",
    forgotDesc: "Inserisci la tua email per ricevere il link di reset",
    sendReset: "Invia link di reset",
    sending: "Invio in corso...",
    backToLogin: "Torna al login",
    checkEmail: "Controlla la tua email",
    resetSent: "Ti abbiamo inviato un link per reimpostare la password.",
    welcome: "Benvenuto!",
    loginSuccess: "Accesso effettuato.",
    accountCreated: "Account creato!",
    accountCreatedDesc: "Il tuo account è stato creato con successo.",
    accountCreatedConfirmEmailDesc: "Ti abbiamo inviato un'email di conferma. Aprila per attivare l'account prima di accedere.",
    accountAlreadyExistsDesc: "Esiste già un account per questa email. Controlla la casella di posta o prova ad accedere.",
    invalidCredentials: "Email o password non corrette. Riprova oppure reimposta la password.",
    referralInvite: "Sei stato invitato da un creator: registrati per attivare l'invito.",
    resetEmailSent: "Email inviata!",
    resetEmailDesc: "Controlla la tua casella per il link di reset.",
    error: "Errore",
    passwordHint: "Minimo 6 caratteri. Evita password comuni come \"123456\" o \"password\".",
    passwordWeakError: "La password è troppo comune o compromessa. Scegli una password più sicura.",
    quickStart: "Inizia in 10 secondi",
    quickStartDesc: "Nessuna carta richiesta · 7 giorni gratis · Cancella quando vuoi",
    useEmail: "Continua con email",
    benefit1: "Link in bio illimitati",
    benefit2: "Analytics dettagliate in tempo reale",
    benefit3: "Vendi prodotti e servizi senza commissioni",
  },
  // Reset password
  resetPassword: {
    backToLogin: "Torna al login",
    newPassword: "Nuova password",
    confirmPassword: "Conferma password",
    update: "Aggiorna password",
    updating: "Aggiornamento...",
    updated: "Password aggiornata",
    updatedDesc: "Puoi ora accedere con la tua nuova password.",
    goToLogin: "Vai al login",
    invalidLink: "Link non valido",
    invalidLinkDesc: "Questo link di reset non è valido o è scaduto. Richiedi un nuovo link dalla pagina di login.",
    enterNew: "Inserisci la tua nuova password",
    mismatch: "Le password non corrispondono.",
    tooShort: "La password deve avere almeno 6 caratteri.",
    success: "Password aggiornata!",
    successDesc: "La tua password è stata cambiata con successo.",
    error: "Errore",
  },
  // NotFound
  notFound: {
    title: "404",
    message: "Oops! Pagina non trovata",
    backHome: "Torna alla Home",
  },
  // Contatti
  contatti: {
    back: "Torna alla home",
    title: "Contattaci",
    desc: "Invia suggerimenti, segnala bug o fai domande",
    categories: {
      suggestion: "💡 Suggerimento",
      bug: "🐛 Bug",
      question: "❓ Domanda",
      other: "📝 Altro",
    },
    yourEmail: "La tua email",
    category: "Categoria",
    subject: "Oggetto",
    subjectPlaceholder: "Di cosa si tratta?",
    message: "Messaggio",
    messagePlaceholder: "Descrivi in dettaglio...",
    send: "Invia messaggio",
    sending: "Invio in corso...",
    sent: "Messaggio inviato!",
    sentDesc: "Grazie per averci scritto, ti risponderemo al più presto.",
    sendAnother: "Invia un altro messaggio",
    enterEmail: "Inserisci la tua email",
    error: "Errore",
    errorDesc: "Impossibile inviare il messaggio.",
  },
  // Chi siamo
  chiSiamo: {
    badge: "La nostra missione",
    title1: "Aiutiamo i creator a ",
    titleHighlight: "vendere di più",
    desc: "TuttiIMieiLink nasce con un obiettivo chiaro: trasformare il tuo link-in-bio da una semplice lista di link in uno strumento di vendita potente, con analytics, deeplink e protezione da segnalazioni.",
    stats: [
      { value: "10K+", label: "Creator attivi" },
      { value: "50K+", label: "Pagine create" },
      { value: "2M+", label: "Click tracciati" },
      { value: "99.9%", label: "Uptime garantito" },
    ],
    timelineTitle: "Il nostro percorso",
    milestones: [
      { year: "2024", title: "L'idea nasce", desc: "Stanchi di link-in-bio generici che non convertono, abbiamo iniziato a costruire qualcosa di diverso." },
      { year: "2024", title: "Lancio beta", desc: "Prime 500 pagine create. Il feedback dei creator ci ha guidato verso Deeplink™ e analytics avanzati." },
      { year: "2025", title: "Crescita esplosiva", desc: "10.000+ creator si affidano a TuttiIMieiLink per vendere prodotti digitali e far crescere il proprio brand." },
      { year: "2025", title: "Il futuro", desc: "A/B testing, pixel tracking, lead capture e molto altro. Stiamo solo iniziando." },
    ],
    earningBadge: "UNICI IN ITALIA",
    earningTitle1: "Ti paghiamo per ogni ",
    earningTitleHighlight: "click ricevuto",
    earningDesc: "Siamo l'unica piattaforma link-in-bio che condivide i ricavi con i creator. Più traffico porti, più guadagni. È semplice.",
    earningCards: [
      { title: "€0.005 / click", subtitle: "Piano Free", desc: "Anche con il piano gratuito inizi a guadagnare per ogni click ricevuto sui tuoi link." },
      { title: "€0.01 / click", subtitle: "Piano Premium", desc: "Con Creator o Agency raddoppi il guadagno per click. Il doppio del valore, lo stesso traffico.", recommended: "CONSIGLIATO" },
      { title: "€10 soglia", subtitle: "Payout PayPal", desc: "Raggiungi €10 di saldo e richiedi il pagamento direttamente sul tuo conto PayPal." },
    ],
    howItWorksTitle: "Come funziona?",
    howItWorksSteps: [
      "Crea la tua pagina e aggiungi i tuoi link",
      "Condividi il tuo link-in-bio sui social",
      "Ogni click viene tracciato e accreditato",
      "Raggiungi €10 e richiedi il payout PayPal",
    ],
    valuesTitle: "I nostri valori",
    valuesDesc: "Tutto quello che facciamo è guidato da questi principi.",
    values: [
      { title: "Conversioni prima di tutto", desc: "Ogni feature è pensata per farti vendere di più, non solo per essere bella." },
      { title: "Protezione del creator", desc: "Deeplink™ e Shield proteggono il tuo account dalle segnalazioni." },
      { title: "Community driven", desc: "Il feedback dei creator guida ogni nostra decisione di prodotto." },
    ],
  },
  // Legal pages
  terms: {
    title: "Termini d'uso",
    lastUpdate: "Ultimo aggiornamento: Marzo 2026",
    sections: [
      { title: "1. Accettazione dei termini", content: "Accedendo e utilizzando TuttiIMieiLink (\"la Piattaforma\"), accetti di essere vincolato dai presenti Termini d'uso. Se non accetti questi termini, ti invitiamo a non utilizzare il servizio." },
      { title: "2. Descrizione del servizio", content: "TuttiIMieiLink è una piattaforma che consente ai creator di creare pagine link-in-bio personalizzate, vendere prodotti digitali, raccogliere lead e monitorare le performance tramite analytics avanzati." },
      { title: "3. Registrazione e account", content: "Per utilizzare alcune funzionalità della Piattaforma è necessario creare un account. L'utente è responsabile della riservatezza delle proprie credenziali e di tutte le attività svolte tramite il proprio account." },
      { title: "4. Piani e pagamenti", content: "La Piattaforma offre piani gratuiti e a pagamento. I piani a pagamento vengono fatturati mensilmente o annualmente tramite Stripe. L'utente può gestire o annullare il proprio abbonamento in qualsiasi momento dalla dashboard." },
      { title: "5. Contenuti dell'utente", content: "L'utente mantiene la proprietà di tutti i contenuti caricati sulla Piattaforma. Concede a TuttiIMieiLink una licenza limitata per ospitare e visualizzare tali contenuti ai fini dell'erogazione del servizio." },
      { title: "6. Uso accettabile", content: "L'utente si impegna a non utilizzare la Piattaforma per scopi illegali, per diffondere contenuti offensivi, spam o malware. TuttiIMieiLink si riserva il diritto di sospendere gli account che violano questi termini." },
      { title: "7. Programma guadagni per click", content: "Gli utenti possono guadagnare una commissione per ogni click ricevuto sulle proprie pagine. Le tariffe e le condizioni di pagamento sono soggette a modifica con preavviso. Il prelievo è disponibile al raggiungimento della soglia minima di €10." },
      { title: "8. Limitazione di responsabilità", content: "La Piattaforma viene fornita \"così com'è\". TuttiIMieiLink non garantisce un funzionamento ininterrotto e non è responsabile per eventuali danni derivanti dall'uso del servizio." },
      { title: "9. Modifiche ai termini", content: "TuttiIMieiLink si riserva il diritto di modificare i presenti termini in qualsiasi momento. Le modifiche saranno comunicate tramite email o notifica sulla Piattaforma." },
      { title: "10. Contatti", content: "Per domande relative ai presenti termini, contattaci alla pagina <a>Contatti</a>." },
    ],
  },
  privacy: {
    title: "Privacy Policy",
    lastUpdate: "Ultimo aggiornamento: Marzo 2026",
    sections: [
      { title: "1. Titolare del trattamento", content: "Il titolare del trattamento dei dati è TuttiIMieiLink. Per contattarci, visita la pagina <a>Contatti</a>." },
      { title: "2. Dati raccolti", content: "Raccogliamo i seguenti dati:", list: ["Dati di registrazione: email, nome visualizzato", "Dati di utilizzo: visualizzazioni pagina, click sui link, referrer", "Dati di pagamento: gestiti interamente da Stripe; non conserviamo dati di carte di credito", "Dati tecnici: indirizzo IP, browser, dispositivo (per analytics)"] },
      { title: "3. Finalità del trattamento", content: "I dati vengono utilizzati per:", list: ["Erogare il servizio e gestire l'account utente", "Fornire analytics e statistiche sulle performance delle pagine", "Gestire pagamenti e abbonamenti", "Calcolare i guadagni per click", "Migliorare il servizio e l'esperienza utente"] },
      { title: "4. Base giuridica", content: "Il trattamento dei dati si basa sul consenso dell'utente al momento della registrazione e sull'esecuzione del contratto di servizio." },
      { title: "5. Condivisione dei dati", content: "Non vendiamo i dati degli utenti a terzi. Condividiamo i dati solo con:", list: ["Stripe: per la gestione dei pagamenti", "Provider di hosting: per l'erogazione del servizio"] },
      { title: "6. Conservazione dei dati", content: "I dati vengono conservati per la durata dell'account attivo e per il periodo richiesto dalla normativa vigente dopo la cancellazione." },
      { title: "7. Diritti dell'utente", content: "In conformità al GDPR, l'utente ha diritto di:", list: ["Accedere ai propri dati personali", "Richiedere la rettifica o la cancellazione dei dati", "Opporsi al trattamento", "Richiedere la portabilità dei dati"] },
      { title: "8. Sicurezza", content: "Adottiamo misure di sicurezza tecniche e organizzative per proteggere i dati personali, inclusa la crittografia delle comunicazioni e l'accesso limitato ai dati." },
    ],
  },
  cookie: {
    title: "Cookie Policy",
    lastUpdate: "Ultimo aggiornamento: Marzo 2026",
    sections: [
      { title: "1. Cosa sono i cookie", content: "I cookie sono piccoli file di testo memorizzati sul dispositivo dell'utente quando visita un sito web. Vengono utilizzati per migliorare l'esperienza di navigazione e fornire funzionalità essenziali." },
      { title: "2. Cookie utilizzati", content: "" },
      { title: "Cookie tecnici (necessari)", content: "Questi cookie sono essenziali per il funzionamento della Piattaforma:", list: ["Sessione di autenticazione: per mantenere l'accesso all'account", "Preferenze utente: per memorizzare le impostazioni"], isH3: true },
      { title: "Cookie analitici", content: "Utilizziamo cookie analitici per comprendere come gli utenti interagiscono con la Piattaforma:", list: ["Google Analytics: se configurato dall'utente sulle proprie pagine", "Analytics interni: per tracciare visualizzazioni e click"], isH3: true },
      { title: "Cookie di terze parti", content: "Alcuni cookie possono essere impostati da servizi di terze parti:", list: ["Stripe: per la gestione sicura dei pagamenti", "Meta Pixel / TikTok Pixel: se configurati dall'utente sulle proprie pagine"], isH3: true },
      { title: "3. Gestione dei cookie", content: "L'utente può gestire le preferenze sui cookie tramite le impostazioni del proprio browser. La disabilitazione di alcuni cookie potrebbe influire sul funzionamento della Piattaforma." },
      { title: "4. Durata dei cookie", content: "", list: ["Cookie di sessione: vengono eliminati alla chiusura del browser", "Cookie persistenti: rimangono sul dispositivo per un periodo definito o fino alla cancellazione manuale"] },
      { title: "5. Aggiornamenti", content: "La presente Cookie Policy può essere aggiornata periodicamente. Eventuali modifiche saranno pubblicate su questa pagina." },
      { title: "6. Contatti", content: "Per domande sulla Cookie Policy, visita la pagina <a>Contatti</a>." },
    ],
  },
  // Dashboard
  copilot: {
    title: "Growth Copilot",
    intro: "Il tuo stratega AI: analizza i dati reali della tua pagina (visite, click, vendite, lead) e ti dice cosa fare adesso.",
    empty: "Chiedimi qualsiasi cosa sulla crescita della tua pagina.",
    thinking: "Sto analizzando i tuoi dati…",
    placeholder: "Es. Come aumento i click sui miei link?",
    errTitle: "Copilot non disponibile",
    errRate: "Troppe richieste, riprova tra poco.",
    errCredits: "Crediti AI esauriti.",
    errNoPage: "Crea prima la tua pagina.",
    errGeneric: "Errore, riprova.",
    suggestions: [
      "Cosa devo migliorare questa settimana?",
      "Come aumento i click sui miei link?",
      "Come guadagno di più dalla mia pagina?",
      "Analizza il mio funnel e dimmi dove perdo visitatori",
    ],
  },
  dashboard: {
    home: "Home",
    yourPage: "La tua pagina",
    yourPageDesc: "Crea e personalizza la tua pagina link-in-bio",
    editPage: "Modifica Pagina",
    editLinks: "I tuoi Link",
    analyticsTitle: "Analytics",
    feedback: "Feedback",
    referral: "Referral",
    earnings: "Guadagni",
    collaborations: "Collaborazioni",
    testimonials: "Testimonianze",
    socialProof: "Social Proof",
    abTest: "A/B Test",
    loading: "Caricamento...",
    subscription: "Abbonamento",
    refresh: "Aggiorna",
    checking: "Verifica in corso...",
    activePlan: "Piano attivo",
    nextRenewal: "Prossimo rinnovo:",
    manageSubscription: "Gestisci abbonamento",
    freePlan: "Piano Free",
    noSubscription: "Nessun abbonamento attivo",
    choosePlan: "Scegli un piano",
    premiumFeature: "Funzionalità Premium",
    upgradeToAccess: "Passa a un piano PRO per accedere a questa funzionalità.",
    unlockTitle: "Sblocca tutto il potenziale",
    unlockDesc: "Passa a un piano premium per accedere a <strong>statistiche avanzate</strong>, <strong>prodotti digitali</strong>, <strong>lead capture</strong>, <strong>pixel tracking</strong>, <strong>A/B test</strong> e link illimitati.",
    discoverPlans: "Scopri i piani premium",
    lockedAnalytics: "Analytics",
    lockedProducts: "Prodotti",
    lockedAI: "AI",
    lockedBooking: "Booking",
    lockedMembership: "Membership",
    lockedSmartBio: "Smart Bio",
    portalError: "Impossibile aprire il portale.",
    trialTitle: "Periodo di prova gratuita",
    trialRemaining: "{{days}} giorni rimanenti nel tuo trial",
    trialUrgent: "Solo {{days}} giorni e {{hours}} ore rimasti!",
    trialProgress: "Giorno {{used}} di {{total}}",
    trialCta: "Attiva il piano ora per non perdere l'accesso alle funzionalità premium.",
    trialUpgrade: "Attiva il piano",
    error: "Errore",
    saved: "Salvato!",
    save: "Salva",
    saving: "Salvataggio...",
    cancel: "Annulla",
    delete: "Elimina",
    add: "Aggiungi",
    // PageEditor
    pageSettings: "Impostazioni pagina",
    pagePhoto: "Foto della pagina",
    uploading: "Caricamento...",
    usernameLabel: "Username (URL della pagina)",
    usernamePlaceholder: "tuousername",
    usernameRequired: "Lo username è obbligatorio.",
    usernameInvalid: "Lo username può contenere solo lettere, numeri, - e _",
    titleLabel: "Titolo",
    titlePlaceholder: "Il tuo nome o brand",
    bioLabel: "Bio",
    bioPlaceholder: "Descrivi chi sei...",
    themeLabel: "Tema della pagina",
    customizeColors: "Personalizza colori",
    resetDefault: "Ripristina default",
    colorBg: "Sfondo",
    colorCard: "Card",
    colorText: "Testo",
    colorAccent: "Accento",
    fontLabel: "Font della pagina",
    previewLabel: "Anteprima tema",
    saveSettings: "Salva impostazioni",
    settingsSaved: "Le impostazioni della pagina sono state aggiornate.",
    duplicateUsername: "Questo username è già in uso. Scegline un altro.",
    cantSave: "Impossibile salvare le impostazioni.",
    deletePage: "Elimina pagina",
    deletePageConfirm: "Eliminare la pagina?",
    deletePageDesc: "Questa azione è irreversibile. La pagina, tutti i link e le statistiche associate verranno eliminati permanentemente.",
    deleting: "Eliminazione...",
    deleteForever: "Elimina definitivamente",
    pageDeleted: "Pagina eliminata",
    pageDeletedDesc: "La tua pagina è stata rimossa.",
    cantDelete: "Impossibile eliminare la pagina.",
    photoUpdated: "Foto aggiornata!",
    photoTooBig: "L'immagine deve essere inferiore a 2MB.",
    cantUploadPhoto: "Impossibile caricare la foto.",
    yourName: "Il tuo nome",
    yourBio: "La tua bio...",
    // Preview links
    previewInstagram: "Instagram",
    previewYouTube: "YouTube",
    previewWebsite: "Il mio sito",
    // LinkEditor
    yourLinks: "I tuoi link",
    savePageFirst: "Salva prima le impostazioni della pagina per aggiungere link.",
    linkTitlePlaceholder: "Titolo del link",
    linkUrlPlaceholder: "https://esempio.com",
    linkAdded: "Link aggiunto!",
    cantAddLink: "Impossibile aggiungere il link.",
    invalidUrl: "L'URL inserito non è valido.",
    urlNotReachable: "Il sito web inserito non esiste o non è raggiungibile. Controlla l'URL e riprova.",
    cantLoadLinks: "Impossibile caricare i link.",
    linkDeleted: "Link eliminato.",
    linkUpdated: "Link aggiornato!",
    cantUpdateLink: "Impossibile aggiornare il link.",
    noLinksYet: "Nessun link ancora. Aggiungine uno sopra!",
    linkLimitReached: "Limite raggiunto",
    linkLimitDesc: "Il piano gratuito permette massimo {{limit}} link. Passa a un piano a pagamento per link illimitati.",
    linkLimitUpgrade: "Hai raggiunto il limite di {{limit}} link del piano gratuito.",
    upgradeToCreator: "Passa a Creator",
    unlimitedLinks: "per link illimitati.",
    // Analytics
    analytics: "Analytics",
    totalViews: "Visite totali",
    totalClicks: "Click totali",
    ctr: "CTR",
    sales: "Vendite",
    revenue: "Fatturato",
    leadsCollected: "Lead raccolti",
    last30days: "Ultimi 30 giorni",
    salesAndRevenue: "Vendite e fatturato (30 giorni)",
    clicksPerLink: "Click per link",
    topReferrer: "Top referrer",
    noReferrerYet: "Nessun referrer registrato ancora.",
    visits: "visite",
    visitsChart: "Visite",
    clicksChart: "Click",
    salesChart: "Vendite",
    revenueChart: "Fatturato",
    // ProductEditor
    products: "Prodotti",
    digitalProducts: "Prodotti Digitali",
    digitalProductsLockedDesc: "La vendita di prodotti è disponibile con il piano Creator o superiore.",
    digitalProductsSellDesc: "Vendi ebook, template, corsi e prodotti fisici direttamente dalla tua pagina.",
    unlockWithCreator: "Sblocca con Creator",
    discoverPlansLink: "Scopri i piani",
    productNamePlaceholder: "Nome prodotto *",
    productDescPlaceholder: "Descrizione (opzionale)",
    productPricePlaceholder: "Prezzo (€) *",
    productFilePlaceholder: "File prodotto (PDF, ZIP...)",
    productCoverPlaceholder: "Immagine copertina",
    invalidPrice: "Prezzo non valido",
    productCreated: "Prodotto creato!",
    createProduct: "Crea prodotto",
    productUpdated: "Prodotto aggiornato!",
    replaceFile: "Sostituisci file",
    addFile: "Aggiungi file",
    replaceCover: "Sostituisci copertina",
    addCover: "Aggiungi copertina",
    noFile: "Nessun file",
    deleteProductConfirm: "Eliminare questo prodotto?",
    deleteAllProducts: "Elimina tutti",
    deleteAllProductsConfirm: "Sei sicuro di voler eliminare TUTTI i prodotti? Questa azione è irreversibile.",
    allProductsDeleted: "Tutti i prodotti sono stati eliminati",
    noProductsYet: "Nessun prodotto ancora. Aggiungi il tuo primo prodotto!",
    typeDigital: "Digitale",
    typePhysical: "Fisico",
    physicalProductNote: "Per i prodotti fisici, al checkout verrà richiesto l'indirizzo di spedizione. Riceverai i dettagli dell'ordine e l'indirizzo via email.",
    shippingCostPlaceholder: "Costo spedizione (€)",
    shippingCostHint: "0 = spedizione gratuita",
    shipping: "Spedizione",
    csvImportTitle: "Importa da CSV / Excel",
    csvImportDesc: "Carica un file CSV o Excel con colonne: title, description, price, currency. I prodotti verranno creati come fisici.",
    csvSelectFile: "Seleziona file CSV o Excel",
    csvDownloadTemplate: "Scarica template",
    csvNoRows: "Il file non contiene righe di dati.",
    csvRow: "Riga",
    csvMissingTitle: "titolo mancante",
    csvInvalidPrice: "prezzo non valido:",
    csvMaxRows: "Massimo 100 prodotti per importazione.",
    csvParseError: "Errore nella lettura del file. Verifica il formato.",
    csvImportSuccess: "{{count}} prodotti importati con successo!",
    csvImporting: "Importazione...",
    csvConfirmImport: "Importa {{count}} prodotti",
    csvHeaderTitle: "Titolo",
    csvHeaderDesc: "Descrizione",
    csvHeaderPrice: "Prezzo",
    ordersTitle: "Ordini prodotti fisici",
    ordersDesc: "{{count}} ordini ricevuti",
    orderBuyer: "Acquirente",
    orderAddress: "Indirizzo di spedizione",
    orderShippingStatus: "Stato spedizione",
    orderNotes: "Note",
    orderNotesPlaceholder: "Tracking, note interne...",
    orderUpdated: "Ordine aggiornato",
    orderDate: "Data",
    orderProduct: "Prodotto",
    orderBuyerName: "Nome destinatario",
    orderPrice: "Prezzo",
    csvExported: "CSV esportato con successo",
    noAddress: "Indirizzo non disponibile",
    orderStatus_pending: "In attesa",
    orderStatus_processing: "In lavorazione",
    orderStatus_shipped: "Spedito",
    orderStatus_delivered: "Consegnato",
    // EarningsPanel
    earningsRateInfo: "Guadagni <strong>{{rate}}</strong> per ogni click ai tuoi link.",
    earningsUpgrade: "Passa a premium per raddoppiare!",
    earningsPPCOnly: "Questo è solo il programma Pay-Per-Click. Le donazioni e gli abbonamenti vanno direttamente sul tuo Stripe — ",
    stripeDashboardLink: "gestisci il conto bancario su dashboard.stripe.com",
    openStripeDashboard: "Apri Stripe Dashboard",
    balance: "Saldo",
    totalEarned: "Totale guadagnato",
    withdrawn: "Prelevato",
    paypalEmail: "Email PayPal",
    paypalPlaceholder: "la-tua-email@paypal.com",
    paypalSaved: "Email PayPal aggiornata.",
    requestPayout: "Richiedi payout",
    payoutMin: "min. {{amount}}",
    payoutSending: "Invio...",
    payoutSent: "Richiesta inviata!",
    payoutSentDesc: "Payout di €{{amount}} in elaborazione.",
    payoutMissingEmail: "Inserisci prima la tua email PayPal.",
    payoutMissing: "Mancano {{amount}} per raggiungere la soglia minima.",
    payoutHistory: "Storico richieste",
    payoutCompleted: "Completato",
    payoutRejected: "Rifiutato",
    payoutPending: "In attesa",
    attention: "Attenzione",
    // Onboarding
    onboardingWelcome: "Benvenuto! Configuriamo la tua pagina",
    onboardingSubtitle: "Solo 3 passaggi per essere online",
    publishBannerTitle: "La tua pagina non è ancora online — pubblicala ora",
    publishBannerDesc: "Ti manca un solo passo: scegli il tuo username, aggiungi il primo link e la tua pagina è pronta da condividere nella bio dei tuoi social. Ci vogliono 2 minuti.",
    onboardingStep1: "Profilo",
    onboardingStep1Desc: "Scegli il tuo username",
    onboardingStep2: "Personalizza",
    onboardingStep2Desc: "Titolo e bio",
    onboardingStep3: "Primo link",
    onboardingStep3Desc: "Aggiungi un link",
    profilePhoto: "Foto profilo",
    profilePhotoHint: "Opzionale, max 2MB",
    chooseUsername: "Scegli il tuo username",
    usernameMin3: "Minimo 3 caratteri",
    pageTitle: "Titolo della pagina",
    pageBio: "Bio",
    pageBioPlaceholder: "Descrivi chi sei in poche parole...",
    editLaterHint: "Puoi modificare tutto in seguito dalla dashboard.",
    firstLinkHint: "Aggiungi il tuo primo link. Potrai aggiungerne altri dopo.",
    linkTitleExample: "es. Instagram",
    linkUrlExample: "https://instagram.com/tuoprofilo",
    optionalStep: "Questo passaggio è opzionale — puoi saltarlo.",
    back: "Indietro",
    next: "Avanti",
    creating: "Creazione...",
    createMyPage: "Crea la mia pagina",
    pageReady: "La tua pagina è pronta! 🎉",
    pageReadyDesc: "Fantastico! La tua pagina link-in-bio è stata creata con successo.",
    goToDashboard: "Vai alla dashboard",
    pageCreatedToast: "Pagina creata! 🎉",
    pageCreatedToastDesc: "Ora personalizza la tua dashboard.",
    usernameInUse: "Username già in uso. Scegline un altro.",
    pageCreateError: "Errore nella creazione della pagina.",
    uploadFailed: "Upload fallito.",
    // Onboarding Checklist
    checklistTitle: "Configura la tua pagina",
    checklistAllDone: "Tutto completato! 🎉",
    checklistDismiss: "Nascondi checklist",
    checklistAvatar: "Aggiungi una foto profilo",
    checklistAvatarDesc: "I profili con foto ricevono il 40% in più di click.",
    checklistBio: "Scrivi una bio",
    checklistBioDesc: "Racconta ai visitatori chi sei e cosa fai.",
    checklistLinks: "Aggiungi almeno 3 link",
    checklistLinksDesc: "Più link = più possibilità di conversione.",
    checklistShare: "Condividi la tua pagina",
    checklistShareDesc: "Invia il link ai tuoi follower sui social.",
    checklistShareAction: "Condividi",
    checklistPremium: "Attiva un piano Premium",
    checklistPremiumDesc: "Sblocca analytics, lead capture e guadagni per click.",
    checklistPremiumAction: "Vedi piani",
    // PagePreview
    openPage: "Apri pagina",
    copyUrl: "Copia URL",
    qrCode: "QR Code",
    downloadPng: "Scarica PNG",
    // FeedbackForm
    contactTeam: "Contatta il team",
    contactTeamDesc: "Invia suggerimenti, segnala bug o fai domande",
    feedbackSent: "Messaggio inviato!",
    feedbackSentDesc: "Grazie per il tuo feedback, lo leggeremo al più presto.",
    categoryLabel: "Categoria",
    categorySuggestion: "💡 Suggerimento",
    categoryBug: "🐛 Bug",
    categoryQuestion: "❓ Domanda",
    categoryOther: "📝 Altro",
    subjectLabel: "Oggetto",
    subjectPlaceholder: "Di cosa si tratta?",
    messageLabel: "Messaggio",
    messagePlaceholder: "Descrivi in dettaglio...",
    sendMessage: "Invia messaggio",
    sending: "Invio in corso...",
    feedbackReplies: "{{count}} risposta/e dal team",
    feedbackAdminReply: "Risposta dal team",
    // LeadCaptureSettings
    leadCapture: "Lead Capture",
    leadCaptureLockedTitle: "Funzione disponibile con il piano Creator o Agency",
    leadCaptureLockedDesc: "Raccogli email e contatti direttamente dalla tua pagina.",
    upgrade: "Upgrade",
    enableFormOnPage: "Attiva il form sulla pagina",
    enableFormDesc: "I visitatori potranno iscriversi alla tua lista",
    formTitle: "Titolo del form",
    formDescription: "Descrizione",
    leadMagnetUrl: "URL Lead Magnet (opzionale)",
    leadMagnetPlaceholder: "https://esempio.com/ebook.pdf",
    leadMagnetHint: "Dopo l'iscrizione, l'utente verrà reindirizzato a questo link.",
    leadsCollectedCount: "Lead raccolti ({{count}})",
    exportCsv: "Esporta CSV",
    noLeadsYet: "Nessun lead ancora. Attiva il form e condividi la tua pagina!",
    leadDeleted: "Lead eliminato.",
    leadCaptureSaved: "Le impostazioni del lead capture sono state aggiornate.",
    cantSaveLead: "Impossibile salvare.",
    // PixelTrackingSettings
    pixelTracking: "Pixel Tracking",
    pixelTrackingLockedDesc: "Traccia le conversioni con Meta Pixel, TikTok Pixel e Google Analytics direttamente dalla tua pagina.",
    metaPixelId: "Meta Pixel ID",
    metaPixelPlaceholder: "Es. 123456789012345",
    metaPixelHint: "Trovi l'ID nel tuo Meta Events Manager",
    tiktokPixelId: "TikTok Pixel ID",
    tiktokPixelPlaceholder: "Es. ABCDEF123456",
    tiktokPixelHint: "Trovi l'ID nel TikTok Ads Manager → Events",
    googleAnalyticsId: "Google Analytics ID",
    googleAnalyticsPlaceholder: "Es. G-XXXXXXXXXX",
    googleAnalyticsHint: "Trovi l'ID in Google Analytics → Amministrazione → Flussi di dati",
    pixelSaved: "Pixel salvati!",
    savePixels: "Salva pixel",
    // ABTestSettings
    abTestPosition: "A/B Test Posizione",
    abTestLockedDesc: "Testa automaticamente l'ordine dei link nella tua pagina per scoprire quale posizione genera più click.",
    abTestEnabled: "L'ordine dei link viene randomizzato per ogni visitatore. I dati si aggiornano man mano che raccogli click.",
    abTestDisabled: "Attiva per mostrare i link in ordine casuale ai visitatori e scoprire quale posizione performa meglio.",
    abTestActivated: "A/B Test attivato!",
    abTestDeactivated: "A/B Test disattivato",
    trackedClicksWithPos: "Click tracciati con posizione",
    noDataYetEnabled: "Nessun dato ancora. I risultati appariranno quando i visitatori inizieranno a cliccare.",
    noDataYetDisabled: "Attiva l'A/B test per iniziare a raccogliere dati.",
    resultsPerLink: "Risultati per link",
    deletedLink: "Link eliminato",
    positionLabel: "Pos.",
    positionWinner: "🏆 Posizione {{pos}} è il vincitore",
    clicks: "click",
    // Default values
    defaultFormTitle: "Iscriviti alla newsletter",
    defaultFormDesc: "Ricevi aggiornamenti esclusivi direttamente nella tua inbox.",
    // BundleEditor
    bundleTitle: "Bundle",
    createBundle: "Crea bundle",
    bundleNamePlaceholder: "Nome del bundle (es. Pack Completo)",
    bundleDescPlaceholder: "Descrizione (opzionale)",
    percentDiscount: "% di sconto",
    fixedDiscount: "centesimi di sconto",
    selectProducts: "Seleziona prodotti ({{count}} selezionati):",
    selectMin2: "Seleziona almeno 2 prodotti",
    noProductsForBundle: "Nessun prodotto. Crea prima dei prodotti digitali.",
    originalPrice: "Prezzo originale",
    bundleCreated: "Bundle creato!",
    invalidDiscount: "Sconto non valido",
    deleteBundleConfirm: "Eliminare questo bundle?",
    noBundlesYet: "Nessun bundle creato. Crea pacchetti di prodotti a prezzo scontato!",
    bundleProducts: "prodotti",
  },
  // SEO Pages
  seoCreator: {
    metaTitle: "Link in Bio per Creator: vendi e monetizza | TuttiIMieiLink",
    metaDesc: "Link in bio professionale per creator: vendi prodotti digitali, raccogli lead e traccia le conversioni. Alternativa italiana a Linktree, gratis.",
    badge: "Per Creator",
    title: "Link in bio per creator che ",
    titleHighlight: "converte davvero",
    desc: "Non un semplice link-in-bio. TuttiIMieiLink è lo strumento creato per i creator che vogliono trasformare i follower in clienti, raccogliere lead e vendere prodotti digitali.",
    cta: "Inizia gratis",
    viewPlans: "Vedi i piani",
    whyTitle: "Perché i creator scelgono TuttiIMieiLink",
    whyDesc: "I link-in-bio generici non bastano più. Hai bisogno di uno strumento che ti aiuti a monetizzare, non solo a raccogliere click.",
    features: [
      { title: "Link illimitati", desc: "Aggiungi tutti i link che vuoi: social, sito web, portfolio, corsi e molto altro." },
      { title: "Vendi prodotti digitali", desc: "Vendi ebook, preset, template e corsi direttamente dalla tua pagina." },
      { title: "Analytics avanzate", desc: "Traccia visite, click, CTR, vendite e fatturato in tempo reale." },
      { title: "Temi personalizzabili", desc: "Scegli tra temi premium e personalizza colori, font e stile." },
      { title: "A/B Test posizione", desc: "Testa l'ordine dei link per scoprire quale posizione converte di più." },
      { title: "Lead capture", desc: "Raccogli email e nomi dei tuoi visitatori con form integrati." },
    ],
    proofTitle: "Fatto per chi crea contenuti",
    proofDesc: "Che tu sia un influencer, un coach, un artista o un freelance, TuttiIMieiLink ti dà gli strumenti per trasformare la tua audience in un business.",
    stats: [
      { value: "+47%", label: "CTR medio" },
      { value: "3x", label: "Più vendite" },
      { value: "2min", label: "Setup iniziale" },
    ],
    jsonLdDesc: "Link in bio professionale per creator. Vendi prodotti digitali, raccogli lead e traccia le conversioni.",
  },
  seoInstagram: {
    metaTitle: "Link in Bio Instagram: link multipli nella bio | TuttiIMieiLink",
    metaDesc: "Link in bio per Instagram: aggiungi link multipli, vendi prodotti digitali e traccia i click dalla tua bio. Alternativa italiana a Linktree, gratis.",
    badge: "Per Instagram",
    title: "Link in bio per ",
    titleHighlight: "Instagram",
    desc: "Instagram ti dà un solo link nella bio. TuttiIMieiLink ti permette di aggiungerne quanti vuoi, vendere prodotti e tracciare ogni click.",
    cta: "Crea il tuo link in bio",
    problemsTitle: "Il problema del link in bio di Instagram",
    problems: [
      { title: "Un solo link nella bio", desc: "Instagram permette un solo link. Con TuttiIMieiLink ne aggiungi quanti vuoi." },
      { title: "Nessun dato sui click", desc: "Non sai quali link funzionano? Le nostre analytics ti dicono tutto." },
      { title: "Zero vendite dalla bio", desc: "Aggiungi prodotti digitali e vendi direttamente dalla tua pagina link-in-bio." },
    ],
    howTitle: "Come funziona",
    steps: [
      { title: "Crea il tuo account", desc: "Registrati gratis in 30 secondi e scegli il tuo username personalizzato." },
      { title: "Aggiungi i tuoi link", desc: "Inserisci i link al tuo sito, YouTube, shop, corsi o qualsiasi altra risorsa." },
      { title: "Incolla nella bio", desc: "Copia il link della tua pagina e incollalo nella bio di Instagram. Fatto!" },
    ],
    featuresTitle: "Tutto quello che ti serve",
    features: [
      { title: "Link multipli", desc: "Aggiungi quanti link vuoi alla tua pagina." },
      { title: "Analytics in tempo reale", desc: "Visite, click, CTR e referrer per ogni link." },
      { title: "Design personalizzabile", desc: "Temi, colori e font che rispecchiano il tuo brand." },
      { title: "Vendita prodotti", desc: "Vendi ebook, preset e corsi dalla tua bio." },
    ],
    jsonLdDesc: "Link in bio per Instagram. Aggiungi link multipli, vendi prodotti e traccia le conversioni.",
  },
  seoMonetize: {
    metaTitle: "Monetizzare Instagram: come guadagnare nel 2026 | TuttiIMieiLink",
    metaDesc: "Come monetizzare Instagram e guadagnare con i tuoi follower: vendi prodotti digitali, raccogli email e trasforma la bio in un business. Guida 2026.",
    badge: "Guida alla monetizzazione",
    title: "Come ",
    titleHighlight: "monetizzare Instagram",
    titleEnd: " e guadagnare nel 2026",
    desc: "I follower non pagano le bollette. Scopri come trasformare la tua audience Instagram in un vero business con strategie concrete e strumenti professionali.",
    cta: "Inizia a monetizzare",
    problemTitle: "Il problema: follower ≠ soldi",
    problemDesc: "Avere migliaia di follower non basta. Senza una strategia di monetizzazione chiara, stai lasciando soldi sul tavolo. La buona notizia? Non servono milioni di follower per guadagnare. Servono gli strumenti giusti.",
    problemStats: [
      { stat: "82%", label: "dei creator non monetizza" },
      { stat: "1k", label: "follower bastano" },
      { stat: "€500+", label: "al mese possibili" },
      { stat: "2 min", label: "per iniziare" },
    ],
    strategiesTitle: "4 strategie per monetizzare Instagram",
    strategiesDesc: "Ecco come i creator di successo guadagnano con Instagram usando TuttiIMieiLink.",
    strategies: [
      { title: "Vendi prodotti digitali", desc: "Ebook, preset Lightroom, template Canva, corsi online. Crea una volta, vendi all'infinito direttamente dal tuo link in bio." },
      { title: "Raccogli email", desc: "Usa il lead capture integrato per costruire la tua mailing list. Offri un freebie in cambio dell'email e nurtura i tuoi contatti." },
      { title: "Ottimizza con i dati", desc: "Analizza quali link generano più click, quale posizione converte meglio e da dove arriva il tuo traffico." },
      { title: "A/B test automatico", desc: "Testa l'ordine dei link per massimizzare le conversioni. Il sistema identifica automaticamente il vincitore." },
    ],
    readyTitle: "Pronto a monetizzare?",
    readyDesc: "Inizia gratis oggi. Crea la tua pagina, aggiungi i tuoi prodotti e inizia a guadagnare dai tuoi follower Instagram.",
    readyCta: "Crea il tuo account gratis",
    jsonLdHeadline: "Come Monetizzare Instagram nel 2026",
    jsonLdDesc: "Guida completa per monetizzare Instagram con prodotti digitali, lead capture e analytics.",
  },
  referralBanner: {
    badge: "Programma Referral",
    title: "Invita un creator, guadagna il 20% ricorrente",
    desc: "Condividi il tuo link di invito. Per ogni creator che si abbona grazie a te, ricevi automaticamente il 20% del suo abbonamento. Ogni mese. Per sempre.",
    step1Title: "Condividi il link",
    step1Desc: "Dalla tua dashboard",
    step2Title: "Guadagni il 20%",
    step2Desc: "Su ogni rinnovo",
    cta: "Inizia a invitare",
  },
  referral: {
    title: "Programma Referral",
    desc: "Invita altri creator e guadagna il 20% ricorrente su ogni abbonamento generato.",
    yourLink: "Il tuo link di invito",
    copied: "Link copiato!",
    invited: "Invitati",
    subscribed: "Abbonati",
    earned: "Guadagnato",
    history: "Storico commissioni",
    howTitle: "Come funziona?",
    howDesc: "Condividi il tuo link. Quando qualcuno si registra e si abbona, ricevi automaticamente il 20% del suo abbonamento ogni mese.",
  },
  seoProducts: {
    metaTitle: "Vendere Prodotti Digitali Online: ebook, preset, corsi | TuttiIMieiLink",
    metaDesc: "Vendere prodotti digitali online: ebook, preset, template e corsi direttamente da Instagram. Checkout Stripe integrato, zero commissioni. Inizia gratis.",
    badge: "Prodotti digitali",
    title: "Vendere ",
    titleHighlight: "prodotti digitali online",
    titleEnd: " (anche da Instagram)",
    desc: "Trasforma le tue competenze in prodotti digitali e vendili direttamente dalla tua bio Instagram. Nessun sito web, nessuna complessità. Solo vendite.",
    cta: "Inizia a vendere",
    typesTitle: "Cosa puoi vendere",
    typesDesc: "Qualsiasi file digitale può diventare un prodotto. Ecco le categorie più richieste dai creator italiani.",
    types: [
      { title: "Ebook e guide", desc: "Guide PDF, ricettari, manuali tecnici. Crea una volta, vendi all'infinito." },
      { title: "Preset e template", desc: "Preset Lightroom, template Canva, filtri personalizzati per i tuoi follower." },
      { title: "Corsi e workshop", desc: "Video corsi, webinar registrati, materiale didattico in formato digitale." },
      { title: "Risorse premium", desc: "Checklist, planner, spreadsheet e qualsiasi risorsa utile per la tua nicchia." },
    ],
    howTitle: "Come funziona la vendita",
    howSteps: [
      { title: "Carica il tuo prodotto", desc: "Aggiungi titolo, descrizione, prezzo e carica il file dalla dashboard." },
      { title: "Il cliente paga dalla tua pagina", desc: "Il visitatore clicca 'Acquista', inserisce l'email e paga in modo sicuro con Stripe." },
      { title: "Download automatico", desc: "Dopo il pagamento, il cliente riceve un link di download unico e sicuro." },
    ],
    benefitsTitle: "Perché vendere con TuttiIMieiLink",
    benefits: [
      "Checkout sicuro con Stripe integrato",
      "Download automatico dopo il pagamento",
      "Zero commissioni di piattaforma",
      "Gestisci tutto dalla dashboard",
      "Analytics vendite in tempo reale",
      "Copertina prodotto personalizzabile",
    ],
    jsonLdHeadline: "Come Vendere Prodotti Digitali su Instagram",
    jsonLdDesc: "Guida completa per vendere ebook, preset, template e corsi su Instagram con TuttiIMieiLink.",
  },
  ai: {
    generating: "Generazione...",
    generateBio: "Genera con AI",
    suggestTitle: "Suggerisci titolo",
    generateDesc: "Genera descrizione AI",
    error: "Errore AI",
    generateError: "Impossibile generare il contenuto. Riprova.",
  },
  routing: {
    smartRouting: "Smart Routing",
    country: "Paese",
    device: "Dispositivo",
    language: "Lingua",
    selectValue: "Seleziona...",
    altUrlPlaceholder: "URL alternativo",
    addRule: "Aggiungi regola",
    ruleAdded: "Regola aggiunta",
    ruleDeleted: "Regola eliminata",
    rulesLabel: "Regole di routing",
  },
  testimonials: {
    title: "Testimonianze",
    add: "Aggiungi",
    addBtn: "Aggiungi",
    cancel: "Annulla",
    namePlaceholder: "Nome del cliente",
    rolePlaceholder: "Ruolo / azienda (opzionale)",
    quotePlaceholder: "Scrivi la recensione del cliente...",
    rating: "Valutazione",
    added: "Testimonianza aggiunta",
    deleted: "Testimonianza eliminata",
    photoUploaded: "Foto caricata",
    error: "Errore nel salvataggio",
    empty: "Nessuna testimonianza ancora. Aggiungine una per mostrarla sulla tua pagina!",
    hint: "Le testimonianze attive verranno mostrate sulla tua pagina pubblica.",
  },
  seoFree: {
    metaTitle: "Link in Bio Gratis: alternativa italiana a Linktree | TuttiIMieiLink",
    metaDesc: "Link in bio gratis in 2 minuti: alternativa italiana a Linktree con link illimitati, analytics, vendita prodotti e guadagni per click. Inizia gratis ora.",
    badge: "100% Gratis · Nessuna carta richiesta",
    title: "Link in bio gratis: ",
    titleHighlight: "alternativa italiana a Linktree",
    desc: "Crea la tua pagina link-in-bio in 2 minuti. Personalizzala, aggiungi i tuoi link, vendi prodotti digitali e guadagna per ogni click. Tutto gratis, per sempre.",
    cta: "Crea il tuo link gratis",
    viewPlans: "Vedi i piani",
    subCta: "Nessuna carta di credito · Setup in 2 minuti",
    featuresTitle: "Tutto quello che ti serve, gratis",
    featuresDesc: "Mentre altri ti fanno pagare per le funzionalità base, noi te le diamo gratis. Davvero.",
    features: [
      { title: "Link illimitati", desc: "Aggiungi tutti i link che vuoi alla tua pagina. Nessun limite artificiale." },
      { title: "Temi personalizzabili", desc: "Scegli tra diversi temi e font per rendere la tua pagina unica." },
      { title: "Analytics integrati", desc: "Monitora visualizzazioni, click e conversioni con la dashboard dedicata." },
      { title: "Vendita prodotti digitali", desc: "Vendi ebook, corsi e template direttamente dalla tua pagina." },
      { title: "QR Code personale", desc: "Genera e scarica il QR code della tua pagina per condividerlo ovunque." },
      { title: "Guadagni per click", desc: "L'unica piattaforma che ti paga per ogni click ricevuto sulla tua pagina." },
    ],
    howTitle: "Crea il tuo link in bio in 3 step",
    steps: [
      { title: "Registrati gratis", desc: "Crea il tuo account in pochi secondi con email o Google. Nessuna carta richiesta." },
      { title: "Personalizza la tua pagina", desc: "Scegli il tema, aggiungi i link ai tuoi social, sito web e contenuti." },
      { title: "Condividi e guadagna", desc: "Copia il link e aggiungilo alla bio di Instagram, TikTok o YouTube. Inizia a guadagnare." },
    ],
    compTitle: "TuttiIMieiLink vs altri link in bio gratis",
    compDesc: "Non tutti i link in bio gratuiti sono uguali. Ecco cosa ti offriamo in più.",
    compOthers: "Altri strumenti",
    comparisons: [
      { them: "Max 5 link", us: "Link illimitati" },
      { them: "Nessun guadagno", us: "Guadagni per click" },
      { them: "Analytics limitati", us: "Analytics completi" },
      { them: "No vendita prodotti", us: "Vendita integrata" },
      { them: "Branding della piattaforma", us: "Il tuo brand" },
    ],
    proofTitle: "I numeri parlano chiaro",
    stats: [
      { value: "1.000+", label: "Creator attivi" },
      { value: "€0", label: "Per iniziare" },
      { value: "2 min", label: "Setup completo" },
    ],
    jsonLdDesc: "Crea il tuo link in bio gratis con TuttiIMieiLink. Pagina personalizzabile, analytics, vendita prodotti e guadagni per click.",
  },
  seoInternalLinks: {
    title: "Guide e risorse per creator",
    body: "Crea un <free>link in bio gratis</free> come alternativa italiana a Linktree, ottimizza il tuo <ig>link in bio per Instagram</ig> e scopri come usare un <creator>link in bio per creator</creator> che converte davvero. Vuoi guadagnare? Leggi le guide su come <monetize>monetizzare Instagram</monetize> e <sell>vendere prodotti digitali online</sell>.",
  },
  exitPopup: {
    title: "Aspetta! Non andare via 👋",
    desc: "Stai per perdere l'opportunità di trasformare i tuoi follower in clienti. Prova gratis per 7 giorni, senza rischi.",
    trialBadge: "7 giorni di prova gratuita",
    benefits: [
      "Landing page che converte, non una lista di link",
      "Vendi prodotti digitali senza commissioni",
      "Guadagna per ogni click ricevuto",
      "Analytics e conversioni in tempo reale",
    ],
    cta: "Prova gratis 7 giorni",
    dismiss: "No grazie, preferisco i link normali",
  },
  freeExitPopup: {
    title: "Stai lasciando soldi sul tavolo! 💸",
    desc: "Passa a PRO ora e sblocca il doppio dei guadagni + tutti gli strumenti avanzati.",
    countdown: "Offerta valida per {{minutes}}:{{seconds}}",
    discountBadge: "50% di sconto — Solo per te",
    benefits: [
      "Guadagna €0.01/click invece di €0.005",
      "Analytics avanzate e conversioni",
      "Prodotti digitali e membership",
      "AI Content Generator e Smart Bio",
      "Booking e calendario integrato",
    ],
    cta: "Passa a PRO con il 50% di sconto",
    dismiss: "Continuo col piano gratuito",
  },
  schedule: {
    title: "Programmazione",
    startLabel: "Pubblica da",
    endLabel: "Nascondi dopo",
    from: "Da",
    until: "Fino a",
    clear: "Rimuovi programmazione",
    saved: "Programmazione salvata",
    showCountdown: "Mostra countdown sulla pagina",
    countdownDays: "g",
    countdownHours: "h",
    countdownMinutes: "m",
    countdownSeconds: "s",
    countdownExpired: "Offerta scaduta",
    countdownEndsIn: "Scade tra",
  },
  // Blog
  blog: {
    metaTitle: "Blog | Guide per Creator - TuttiIMieiLink",
    metaDesc: "Guide, strategie e consigli per creator che vogliono monetizzare i social media. Scopri come guadagnare con il tuo link in bio.",
    badge: "Blog & Guide",
    title: "Risorse per Creator",
    subtitle: "Guide pratiche, strategie di monetizzazione e consigli per trasformare i tuoi follower in clienti.",
    readMore: "Leggi l'articolo",
    backToList: "Torna al blog",
    related: "Articoli correlati",
    faqTitle: "Domande frequenti",
    ctaInline: {
      title: "Pronto a monetizzare i tuoi social?",
      desc: "Crea il tuo link-in-bio professionale, vendi prodotti digitali e guadagna per ogni click. Setup in 2 minuti.",
      cta: "Inizia gratis",
    },
    ctaSidebar: {
      title: "Crea il tuo link-in-bio",
      desc: "L'unico che ti paga per ogni click",
      benefits: [
        "Pagina personalizzabile",
        "Vendita prodotti digitali",
        "Analytics avanzate",
        "Guadagni per ogni click",
        "A/B test automatico",
      ],
      earning: "€0.01 / click",
      cta: "Prova gratis 7 giorni",
      sub: "7 giorni gratis · Cancella quando vuoi",
    },
  },
  // Creator Score
  creatorScore: {
    description: "Punteggio di credibilità calcolato automaticamente in base all'attività del creator.",
    levels: {
      legend: "Leggenda",
      expert: "Esperto",
      pro: "Pro",
      rising: "In ascesa",
      new: "Nuovo",
    },
    categories: {
      sales: "Vendite",
      reviews: "Recensioni",
      activity: "Attività",
      seniority: "Anzianità",
    },
  },
  // Storefront (public page: cart, bundle, checkout)
  storefront: {
    cart: "Carrello",
    cartEmpty: "Il carrello è vuoto",
    suggestions: "Potrebbe interessarti",
    total: "Totale",
    emailPlaceholder: "La tua email per il download",
    checkout: "Procedi al checkout",
    checkoutLoading: "Caricamento...",
    enterEmail: "Inserisci la tua email",
    error: "Errore",
    checkoutError: "Impossibile avviare il checkout.",
    addToCart: "Aggiungi al carrello",
    addBundleToCart: "Aggiungi bundle al carrello",
    bundleOffers: "Offerte Bundle",
    includes: "Include",
    reviews: "Recensioni",
    pageNotFound: "Pagina non trovata",
    usernameNotExists: "Questo username non esiste ancora.",
    pageUnavailable: "Pagina non disponibile",
    pageUnavailableDesc: "Questa pagina non è ancora pubblica. Il proprietario deve attivare un piano per renderla visibile.",
    backHome: "Torna alla home",
    thankYou: "Grazie per l'iscrizione!",
    downloadSoon: "Il tuo download si aprirà a breve...",
    namePlaceholder: "Il tuo nome (opzionale)",
    emailFieldPlaceholder: "La tua email",
    submitting: "Invio...",
    downloadFree: "Scarica gratis",
    subscribe: "Iscriviti",
    createdWith: "Creato con",
    collabPartners: "In collaborazione con",
    marketingConsent: "Acconsento a ricevere comunicazioni promozionali via email. Posso disiscrivermi in qualsiasi momento.",
  },
  // AI Auto-Funnel
  autoFunnel: {
    title: "AI Auto-Funnel",
    description: "L'AI analizza i tuoi link, prodotti e analytics per suggerirti l'ordine ottimale, il copy migliore e una strategia di conversione personalizzata.",
    analyze: "Analizza il mio funnel",
    analyzing: "Analisi in corso...",
    strategy: "Strategia consigliata",
    linkSuggestions: "Suggerimenti link",
    productTips: "Consigli prodotti",
    bioSuggestion: "Bio suggerita",
    apply: "Applica",
    applyAll: "Applica tutto",
    reanalyze: "Rianalizza",
    applied: "Suggerimento applicato!",
    allApplied: "Tutte le modifiche sono state applicate!",
    error: "Errore",
    analyzeError: "Impossibile analizzare il funnel.",
  },
  // Heatmap
  heatmap: {
    title: "Heatmap dei Click",
    aiTips: "Suggerimenti AI",
    hot: "Caldo",
    warm: "Tiepido",
    medium: "Medio",
    cool: "Fresco",
    cold: "Freddo",
    suggestions: "Suggerimenti per migliorare",
    error: "Errore",
  },
  // Social Proof
  socialProof: {
    title: "Social Proof Live",
    description: "Mostra notifiche degli acquisti recenti sulla tua pagina pubblica per aumentare le conversioni.",
    saved: "Impostazione salvata!",
    error: "Errore nel salvataggio",
    exampleBought: "ha appena acquistato",
    ago: "fa",
    bought: "ha appena acquistato",
    justNow: "ora",
    minAgo: "min fa",
    daysAgo: "g fa",
  },
  // Collaborations
  collab: {
    title: "Collaborazioni",
    description: "Promuovi altri creator sulla tua pagina e loro promuoveranno te. Imposta lo split dei guadagni personalizzato.",
    invite: "Invita",
    usernamePlaceholder: "Username del creator da invitare",
    messagePlaceholder: "Messaggio (opzionale)",
    splitLabel: "Split guadagni",
    you: "Tu",
    partner: "Partner",
    sendInvite: "Invia invito",
    cancel: "Annulla",
    loading: "Caricamento...",
    pendingIncoming: "Inviti ricevuti",
    pendingOutgoing: "Inviti inviati",
    activeCollabs: "Collaborazioni attive",
    noCollabs: "Nessuna collaborazione attiva. Invita un creator per iniziare!",
    aiTitle: "Trova partner con l'AI",
    aiDescription: "L'AI analizza i profili dei creator sulla piattaforma e ti propone i migliori partner per uno shoutout reciproco.",
    aiFind: "Trova partner",
    aiFinding: "Analisi in corso...",
    aiEmpty: "Nessun partner compatibile trovato per ora. Riprova quando ci saranno piu creator.",
    aiError: "Impossibile generare i match. Riprova.",
    aiRateLimit: "Troppe richieste, riprova tra poco.",
    aiNoCredits: "Crediti AI esauriti.",
    matchScore: "Affinita",
    useShoutout: "Invita con questo messaggio",
    statsTitle: "Click shoutout",
    clicksSent: "Inviati ai partner",
    clicksReceived: "Ricevuti dai partner",
    last30: "ultimi 30 giorni",
    active: "Attiva",
    inviteSent: "Invito inviato!",
    accepted: "Collaborazione accettata!",
    rejected: "Invito rifiutato.",
    cancelled: "Collaborazione annullata.",
    accept: "Accetta",
    reject: "Rifiuta",
    error: "Errore",
  },
  notifications: {
    title: "Notifiche",
    markAllRead: "Segna tutte come lette",
    empty: "Nessuna notifica",
  },
  templates: {
    stepLabel: "Template",
    stepDesc: "Scegli un modello di partenza",
    chooseHint: "Scegli un template per iniziare più velocemente, oppure parti da zero.",
    catAll: "Tutti",
    catCreative: "Creativi",
    catBusiness: "Business",
    catWellness: "Benessere",
    catFood: "Food",
    catEntertainment: "Intrattenimento",
    additionalLinks: "Link inclusi nel template:",
    blank: "Da zero",
    blankDesc: "Pagina vuota, personalizzi tutto tu",
    musician: "Musicista",
    musicianDesc: "Per artisti e musicisti",
    beautician: "Estetista",
    beauticianDesc: "Per centri estetici e beauty",
    coach: "Coach",
    coachDesc: "Per coach, consulenti e formatori",
    wedding: "Wedding Planner",
    weddingDesc: "Per organizzatori di matrimoni",
    restaurant: "Ristorante",
    restaurantDesc: "Per ristoranti e locali",
    tattoo: "Tatuatore",
    tattooDesc: "Per tattoo artist e studi",
    photographer: "Fotografo",
    photographerDesc: "Per fotografi e studi fotografici",
    personalTrainer: "Personal Trainer",
    personalTrainerDesc: "Per personal trainer e fitness coach",
    artist: "Artista",
    artistDesc: "Per artisti, illustratori e pittori",
    nutritionist: "Nutrizionista",
    nutritionistDesc: "Per nutrizionisti e dietologi",
    influencer: "Influencer",
    influencerDesc: "Per content creator e influencer",
    lawyer: "Avvocato",
    lawyerDesc: "Per avvocati e studi legali",
    financialAdvisor: "Consulente Finanziario",
    financialAdvisorDesc: "Per consulenti finanziari e wealth manager",
    psychologist: "Psicologo",
    psychologistDesc: "Per psicologi e psicoterapeuti",
    architect: "Architetto",
    architectDesc: "Per architetti e interior designer",
    dj: "DJ",
    djDesc: "Per DJ e producer musicali",
    podcaster: "Podcaster",
    podcasterDesc: "Per podcaster e creatori audio",
    foodBlogger: "Food Blogger",
    foodBloggerDesc: "Per food blogger e creator di ricette",
    pastryChef: "Pasticceria",
    pastryChefDesc: "Per pasticcerie, cake designer e bakery",
    mealPlanCreator: "Meal Plan Creator",
    mealPlanCreatorDesc: "Per chi vende piani alimentari e ricettari digitali",
    selectPreview: "Seleziona un template per vedere l'anteprima",
    customize: "Personalizza",
    theme: "Tema",
    font: "Font",
    accentColor: "Colore accent",
    customColor: "Personalizzato",
  },
  smartBio: {
    description: "Personalizza la bio e l'ordine dei link in base alla fonte di traffico dei tuoi visitatori. Chi arriva da Instagram vedrà una bio diversa rispetto a chi arriva da Google.",
    noRules: "Nessuna regola Smart Bio. Aggiungi una fonte di traffico per iniziare.",
    customBio: "Bio personalizzata",
    bioPlaceholder: "Lascia vuoto per usare la bio predefinita...",
    linkOrder: "Ordine link personalizzato",
    addSource: "Aggiungi fonte di traffico",
    active: "Attiva",
    inactive: "Disattiva",
    save: "Salva regole Smart Bio",
    saving: "Salvataggio...",
    saved: "Regole Smart Bio salvate!",
    error: "Errore nel salvataggio",
  },
  smartBioLanding: {
    badge: "Smart Bio",
    title: "Una bio diversa per ogni visitatore",
    desc: "Chi arriva da Instagram vede contenuti diversi da chi arriva da Google. Bio personalizzata e ordine link automatico in base alla fonte di traffico.",
    from: "da",
    sources: {
      instagram: "Instagram",
      tiktok: "TikTok",
      google: "Google",
      direct: "Link diretto",
    },
    features: [
      "Bio personalizzata per ogni fonte di traffico",
      "Ordine dei link ottimizzato automaticamente",
      "Supporta Instagram, TikTok, Google, Facebook e altri",
      "Nessuna configurazione tecnica richiesta",
    ],
    demos: [
      { bio: "🔥 Scopri i contenuti esclusivi che condivido solo su Instagram!", links: ["Ultimo Reel ▶️", "Shop Instagram", "Filtri & Preset", "Newsletter"] },
      { bio: "🎵 I miei trend virali e tutorial esclusivi", links: ["Video Virali 🔥", "Tutorial Completi", "Shop TikTok", "Seguimi"] },
      { bio: "👋 Benvenuto! Scopri i miei servizi e prodotti digitali", links: ["Servizi", "Prodotti Digitali", "Chi Sono", "Contattami"] },
      { bio: "Ciao! Ecco tutti i miei link importanti 🚀", links: ["Portfolio", "Blog", "Shop Online", "Contatti"] },
    ],
    autoLabel: "100% automatico ✨",
  },
  booking: {
    services: "Servizi prenotabili",
    addService: "Aggiungi servizio",
    serviceTitle: "Nome del servizio (es. Consulenza 1-on-1)",
    serviceDesc: "Descrizione (opzionale)",
    duration: "Durata (min)",
    price: "Prezzo (€)",
    save: "Salva",
    free: "Gratuito",
    noServices: "Nessun servizio creato ancora.",
    serviceCreated: "Servizio creato!",
    addSlots: "Aggiungi disponibilità",
    selectService: "Servizio",
    chooseService: "Scegli un servizio...",
    date: "Data",
    from: "Dalle",
    to: "Alle",
    generateSlots: "Genera slot",
    noSlots: "Nessuno slot generabile in questo intervallo.",
    slotsCreated: "{{count}} slot creati!",
    upcomingSlots: "Prossimi slot",
    booked: "Prenotato",
    recentBookings: "Prenotazioni recenti",
    name: "Nome",
    service: "Servizio",
    dateTime: "Data/Ora",
    payment: "Pagamento",
    paid: "Pagato",
    bookSession: "Prenota una sessione",
    chooseServicePublic: "Scegli un servizio",
    selectSlot: "Scegli un orario",
    noAvailableSlots: "Nessuno slot disponibile al momento.",
    back: "Indietro",
    yourName: "Il tuo nome",
    yourEmail: "La tua email",
    notesOptional: "Note (opzionale)",
    bookNow: "Prenota ora",
    confirmed: "Prenotazione confermata!",
    confirmationSent: "Riceverai una conferma via email.",
    bookingError: "Errore nella prenotazione",
    tryAgain: "Riprova tra qualche istante.",
    payAndBook: "Paga e prenota",
    confirmingPayment: "Conferma pagamento in corso...",
    paymentConfirmed: "Pagamento confermato e prenotazione effettuata!",
    status: "Stato",
    actions: "Azioni",
    cancelled: "Cancellata",
    rescheduled: "Spostata",
    cancelBooking: "Cancella prenotazione",
    rescheduleBooking: "Sposta prenotazione",
    cancelBookingTitle: "Cancellare questa prenotazione?",
    cancelBookingDesc: "Il visitatore riceverà una notifica via email della cancellazione. Lo slot tornerà disponibile.",
    confirmCancel: "Sì, cancella",
    rescheduleBookingTitle: "Sposta prenotazione",
    rescheduleBookingDesc: "Scegli un nuovo orario per la prenotazione di {{name}}. Il visitatore riceverà una notifica.",
    confirmReschedule: "Conferma spostamento",
    bookingCancelled: "Prenotazione cancellata con successo",
    bookingRescheduled: "Prenotazione spostata con successo",
    recurringAvailability: "Disponibilità ricorrente",
    recurringDesc: "Imposta le regole di disponibilità automatica. Gli slot vengono generati ogni notte per i prossimi giorni.",
    addRule: "Aggiungi regola",
    dayOfWeek: "Giorno della settimana",
    sunday: "Domenica",
    monday: "Lunedì",
    tuesday: "Martedì",
    wednesday: "Mercoledì",
    thursday: "Giovedì",
    friday: "Venerdì",
    saturday: "Sabato",
    advanceDays: "Giorni in anticipo",
    advanceDaysLabel: "{{days}} giorni in anticipo",
    ruleCreated: "Regola di disponibilità creata!",
    generateNow: "Genera ora",
    slotsGeneratedFromRules: "{{count}} slot generati dalle regole!",
  },
  // Blog preview on landing
  blogPreview: {
    title: "Risorse per creator che vogliono vendere di più",
    desc: "Guide, strategie e consigli pratici per monetizzare i tuoi social.",
    viewAll: "Leggi tutti gli articoli",
  },
  // SEO internal linking
  seoInternal: {
    title: "Altre guide utili",
    desc: "Scopri le nostre guide complete per creator e brand",
    descCreator: "Crea il tuo link-in-bio professionale",
    descInstagram: "Ottimizza il link nella bio di Instagram",
    descMonetize: "Strategie per guadagnare con Instagram",
    descProducts: "Vendi ebook, corsi e template",
    descFree: "Inizia gratis con il tuo link-in-bio",
    descBooking: "Accetta prenotazioni online dal link in bio",
  },
  seoBooking: {
    metaTitle: "Prenotazioni Online dal Link in Bio | TuttiIMieiLink",
    metaDesc: "Accetta prenotazioni online direttamente dal tuo link in bio: calendario, pagamento anticipato e promemoria automatici. Con Deeplink™ il cliente prenota senza uscire dal social.",
    badge: "Prenotazioni online · Incluse nel link in bio",
    title: "Prenotazioni online ",
    titleHighlight: "direttamente dal tuo link in bio",
    desc: "Il tuo link in bio diventa un'agenda: i clienti scelgono giorno e ora, pagano subito e ricevono conferma ed email di promemoria. Nessun software di prenotazione da aggiungere.",
    cta: "Attiva le prenotazioni gratis",
    viewPlans: "Vedi i piani",
    subCta: "Nessuna carta richiesta · Attivo in 2 minuti",
    whyTitle: "Tutto quello che serve per gestire le prenotazioni online",
    whyDesc: "Consulenze, lezioni, sedute, appuntamenti in negozio: crea le tue disponibilità e lascia che siano i clienti a prenotare.",
    features: [
      { title: "Calendario con disponibilità", desc: "Imposti giorni, orari e durata: la pagina mostra solo gli slot davvero liberi." },
      { title: "Pagamento al momento della prenotazione", desc: "Incassi con carta, Apple Pay o Google Pay prima dell'appuntamento e riduci i no-show." },
      { title: "Conferme e promemoria automatici", desc: "Email di conferma immediata e promemoria prima dell'appuntamento, senza scriverli a mano." },
      { title: "Riprogrammazione e annullamento", desc: "Il cliente può spostare l'orario e tu ricevi subito la notifica aggiornata." },
      { title: "Statistiche sulle prenotazioni", desc: "Vedi quante persone visitano la pagina, quante prenotano e quanto incassi." },
      { title: "Deeplink™ per non perdere clienti", desc: "Il link si apre nel browser vero e non in quello interno del social: pagamenti e login funzionano al primo colpo." },
    ],
    howTitle: "Come attivare le prenotazioni in 3 passaggi",
    steps: [
      { title: "Crea il tuo link in bio", desc: "Registrati gratis e scegli il tuo indirizzo personale: tuttimieilink.com/iltuonome." },
      { title: "Aggiungi il servizio prenotabile", desc: "Indica nome, durata, prezzo e le fasce orarie in cui sei disponibile." },
      { title: "Condividi il link sui social", desc: "Metti il link nella bio di Instagram, TikTok o YouTube e inizia a ricevere prenotazioni." },
    ],
    deeplinkTitle: "Perché il Deeplink™ fa la differenza sulle prenotazioni",
    deeplinkDesc: "Quando qualcuno tocca un link dentro Instagram o TikTok, la pagina si apre nel browser interno dell'app: sessioni perse, login che non funzionano e pagamenti che si bloccano. Il Deeplink™ di TuttiIMieiLink porta il visitatore nel browser reale del telefono, così il calendario si carica bene e la prenotazione si completa davvero.",
    faqTitle: "Domande frequenti sulle prenotazioni online",
    faqs: [
      { q: "Posso accettare prenotazioni online gratis?", a: "Sì. Crei il tuo link in bio gratis e attivi il servizio prenotabile senza carta di credito. I piani a pagamento aggiungono funzioni avanzate come statistiche estese e servizi illimitati." },
      { q: "I clienti pagano al momento della prenotazione?", a: "Puoi scegliere: incasso anticipato con carta, Apple Pay o Google Pay, oppure prenotazione senza pagamento e saldo di persona." },
      { q: "Come evito le sovrapposizioni di appuntamenti?", a: "Gli slot già prenotati spariscono subito dal calendario pubblico, quindi due persone non possono prendere lo stesso orario." },
      { q: "Il cliente riceve un promemoria?", a: "Sì: conferma via email subito dopo la prenotazione e promemoria automatico prima dell'appuntamento." },
      { q: "Che cos'è il Deeplink™?", a: "È la tecnologia che apre i tuoi link nel browser reale del telefono invece che nel browser interno dei social, così pagamenti, login e prenotazioni non si interrompono." },
      { q: "Serve un altro software di prenotazione?", a: "No. Calendario, pagamenti, email e pagina pubblica sono già dentro TuttiIMieiLink: gestisci tutto dallo stesso pannello del tuo link in bio." },
    ],
  },
  panels: {
    stripeAccount: "Il tuo account Stripe",
    enterBothKeys: "Inserisci entrambe le chiavi",
    error: "Errore",
    uploadError: "Errore upload",
    tipButtonMessage: "Messaggio sul pulsante",
    tipDefaultLabel: "Offrimi un caffè ☕",
    tipSaveError: "Il Tip Jar non è stato salvato. Riprova.",
    saveSettings: "Salva impostazioni",
    newAmount: "Nuovo importo (€)",
    editTier: "Modifica Tier",
    newTier: "Nuovo Tier",
    tierNamePlaceholder: "Nome tier (es. Bronze, Gold, Diamond)",
    tierDescPlaceholder: "Descrizione (cosa include questo tier)",
    pricePerMonth: "Prezzo (€/mese)",
    cancel: "Annulla",
    editContent: "Modifica Contenuto",
    newContent: "Nuovo Contenuto",
    contentTitlePlaceholder: "Titolo del contenuto",
    contentBodyPlaceholder: "Contenuto (testo, link, istruzioni...)",
    loading: "Caricamento...",
    deleteContentConfirm: "Eliminare questo contenuto?",
    searchContacts: "Cerca email o nome...",
    all: "Tutti",
    emailCol: "Email",
    nameCol: "Nome",
    firstVisitCol: "Prima visita",
  },
};

export default it;
